import { ARBITRUM, AVALANCHE, MOONBEAM, TESTNET } from './chains'

export const SUBGRAPH_URLS = {
  [ARBITRUM]: {
    stats: 'https://api.thegraph.com/subgraphs/name/gmx-io/gmx-stats',
    referrals:
      'https://api.thegraph.com/subgraphs/name/gmx-io/gmx-arbitrum-referrals',
    nissohVault: 'https://api.thegraph.com/subgraphs/name/nissoh/gmx-vault',
  },

  [AVALANCHE]: {
    stats: 'https://api.thegraph.com/subgraphs/name/gmx-io/gmx-avalanche-stats',
    referrals:
      'https://api.thegraph.com/subgraphs/name/gmx-io/gmx-avalanche-referrals',
  },

  [TESTNET]: {
    stats: 'https://api.thegraph.com/subgraphs/name/flisko/stats',
    referrals: 'https://api.thegraph.com/subgraphs/name/flisko/referrals',
    nissohVault: 'https://api.thegraph.com/subgraphs/name/flisko/leaderboard',
  },
  [TESTNET]: {
    stats: 'https://api.thegraph.com/subgraphs/name/flisko/stats-moonbeam',
    referrals: 'https://api.thegraph.com/subgraphs/name/flisko/referrals',
    nissohVault: 'https://api.thegraph.com/subgraphs/name/flisko/leaderboard',
  },
  [MOONBEAM]: {
    stats: 'https://graph.beamswap.io/subgraphs/name/beamswap/beamex-stats',
    referrals: 'https://graph.beamswap.io/subgraphs/name/beamswap/beamex-referral',
    nissohVault:
      'https://graph.beamswap.io/subgraphs/name/beamswap/beamex-leaderboard',
  },

  common: {
    chainLink: 'https://api.thegraph.com/subgraphs/name/deividask/chainlink',
  },
}
